import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { IntraDayProfileWidgetState } from './IntraDayProfileWidgetState';

import {
    buildIntraDayProfileStreamSlice,
    IntraDayProfileStreamPayloadType,
} from 'widgets/intraDayProfile/store/data/streamSlice';
import {
    buildIntraDayProfileConfigSlice,
    IntraDayProfileConfigPayloadType,
} from 'widgets/intraDayProfile/store/configuration/configSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildIntradayProfilesComponentSlice } from 'widgets/intraDayProfile/store/intradayProfilesComponentSlice';

const { reducer: streamReducer } = buildIntraDayProfileStreamSlice();
const { reducer: configReducer } = buildIntraDayProfileConfigSlice();
const { reducer: componentReducer } = buildIntradayProfilesComponentSlice();

const widgetStateReducer = combineReducers<IntraDayProfileWidgetState>({
    stream: streamReducer,
    config: configReducer,
    component: componentReducer,
});

export const intraDayProfileWidgetsReducer = createWidgetsReducer<
    IntraDayProfileWidgetState,
    IntraDayProfileConfigPayloadType | IntraDayProfileStreamPayloadType
>(WidgetType.INTRA_DAY_PROFILE, widgetStateReducer);
